module.exports = __webpack_public_path__ + "static/pay-by-link-feature_es-81ac047020b47bf50e0e9dfb3adccdae.svg";